/**
 * SARM SHARK / Shark Supps - Main JavaScript
 * Shopify Theme (converted from WordPress/WooCommerce)
 *
 * Expects window.shopData to be set in the Liquid layout with:
 *   - externalCheckoutUrl  (string)
 *   - exchangeRates        ({ EUR: 1.17, USD: 1.27, AUD: 1.95, CAD: 1.72 })
 *   - freeShippingThreshold (number, in cents)
 */
(function () {
  'use strict';

  // ============================================
  // Utility helpers
  // ============================================
  var CURRENCY_SYMBOLS = {
    GBP: '\u00a3',
    EUR: '\u20ac',
    USD: '$',
    AUD: 'A$',
    CAD: 'C$'
  };

  function getShopData(key) {
    return window.shopData && window.shopData[key] ? window.shopData[key] : null;
  }

  function moneyFormat(cents, currencyCode) {
    var code = currencyCode || getActiveCurrency();
    var rates = getShopData('exchangeRates') || {};
    var rate = rates[code] || 1;
    var symbol = CURRENCY_SYMBOLS[code] || '\u00a3';
    var converted = (cents / 100) * rate;
    return symbol + converted.toFixed(2);
  }

  function formatPriceFromCents(cents) {
    return moneyFormat(cents, getActiveCurrency());
  }

  function getActiveCurrency() {
    try {
      return localStorage.getItem('shark_currency') || 'GBP';
    } catch (e) {
      return 'GBP';
    }
  }

  // ============================================
  // Toast Notifications
  // ============================================
  function showToast(message, type) {
    type = type || 'success';
    var existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'toast-notification toast-' + type;
    toast.innerHTML =
      '<div class="toast-content">' +
      '<span class="toast-icon">' + (type === 'success' ? '\u2713' : '!') + '</span>' +
      '<span class="toast-message">' + message + '</span>' +
      '</div>';
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('show');
    });

    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  }

  function injectToastStyles() {
    if (document.getElementById('shark-toast-styles')) return;
    var style = document.createElement('style');
    style.id = 'shark-toast-styles';
    style.textContent =
      '.toast-notification{position:fixed;bottom:24px;right:24px;z-index:10000;background:#0a0a0a;color:#fff;padding:14px 24px;border-radius:12px;font-size:14px;font-weight:500;box-shadow:0 8px 32px rgba(0,0,0,.2);transform:translateY(100px);opacity:0;transition:all .3s cubic-bezier(.4,0,.2,1);pointer-events:none}' +
      '.toast-notification.show{transform:translateY(0);opacity:1}' +
      '.toast-content{display:flex;align-items:center;gap:10px}' +
      '.toast-icon{width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0}' +
      '.toast-success .toast-icon{background:linear-gradient(135deg,#00aeef,#22d3ee);color:#0a0a0a}' +
      '.toast-error .toast-icon{background:#ef4444;color:#fff}' +
      '@media(max-width:480px){.toast-notification{left:16px;right:16px;bottom:16px}}';
    document.head.appendChild(style);
  }

  // ============================================
  // 1. Mobile Menu
  // ============================================
  function initMobileMenu() {
    var menuBtn = document.querySelector('.mobile-menu-btn, [data-mobile-menu-trigger]');
    var mobileNav = document.querySelector('.mobile-nav, [data-mobile-nav]');
    var mobileNavClose = document.querySelectorAll('.mobile-nav-close, [data-mobile-nav-close]');
    var mobileNavOverlay = document.querySelector('.mobile-nav-overlay, [data-mobile-nav-overlay]');

    if (!menuBtn || !mobileNav) return;

    function openMenu() {
      mobileNav.classList.add('active');
      if (mobileNavOverlay) mobileNavOverlay.classList.add('active');
      menuBtn.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileNav.classList.remove('active');
      if (mobileNavOverlay) mobileNavOverlay.classList.remove('active');
      menuBtn.classList.remove('active');
      document.body.style.overflow = '';
    }

    menuBtn.addEventListener('click', function () {
      mobileNav.classList.contains('active') ? closeMenu() : openMenu();
    });

    mobileNavClose.forEach(function (btn) { btn.addEventListener('click', closeMenu); });
    if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMenu);

    // Submenu toggles
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var submenu = btn.nextElementSibling;
        if (!submenu || !submenu.hasAttribute('data-submenu')) return;
        var isOpen = submenu.classList.contains('active');
        submenu.classList.toggle('active');
        btn.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  // ============================================
  // 2. Cart Drawer (Shopify AJAX Cart API)
  // ============================================
  function initCartSidebar() {
    var cartBtns = document.querySelectorAll('.cart-btn, .site-header__cart, [data-cart-trigger]');
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartClose = document.querySelectorAll('[data-cart-close]');
    var cartOverlay = document.querySelector('[data-cart-overlay]');

    if (!cartDrawer) return;

    function openCart() {
      cartDrawer.classList.add('active');
      if (cartOverlay) cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      cartDrawer.classList.remove('active');
      if (cartOverlay) cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    cartBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    });
    cartClose.forEach(function (btn) { btn.addEventListener('click', closeCart); });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('active')) closeCart();
    });

    window.openCartSidebar = openCart;
    window.closeCartSidebar = closeCart;
  }

  /** Fetch current cart from Shopify */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /** Update cart count badge(s) */
  function updateCartCount(count) {
    document.querySelectorAll('.site-header__cart-count, [data-cart-count]').forEach(function (badge) {
      badge.setAttribute('data-cart-count', count);
    });
    // Update aria-label
    document.querySelectorAll('.cart-btn, .site-header__cart').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Cart (' + count + ' items)');
      btn.setAttribute('data-cart-count', count);
    });
  }

  /** Render cart drawer contents from Shopify cart object */
  function renderCartDrawer(cart) {
    var cartItemsEl = document.querySelector('.cart-items');
    var subtotalEl = document.querySelector('.subtotal-amount');
    var cartFooter = document.querySelector('.cart-footer');
    var currency = getActiveCurrency();

    updateCartCount(cart.item_count);

    if (cartItemsEl) {
      if (cart.items.length === 0) {
        cartItemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p></div>';
      } else {
        var html = '';
        cart.items.forEach(function (item) {
          var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_180x$1') : '';
          var itemPrice = formatPriceFromCents(item.final_line_price);
          html +=
            '<div class="cart-item" data-key="' + item.key + '">' +
              '<div class="cart-item-image">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="cart-item-details">' +
                '<span class="cart-item-name">' + item.product_title + '</span>' +
                (item.variant_title ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '') +
                '<p class="cart-item-price money" data-base-price="' + item.final_line_price + '">' + itemPrice + '</p>' +
                '<div class="cart-item-quantity">' +
                  '<button class="qty-btn minus" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="qty-value">' + item.quantity + '</span>' +
                  '<button class="qty-btn plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
              '</div>' +
              '<button class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove item">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
              '</button>' +
            '</div>';
        });
        cartItemsEl.innerHTML = html;
      }
    }

    if (subtotalEl) {
      subtotalEl.innerHTML = '<span class="money" data-base-price="' + cart.total_price + '">' + formatPriceFromCents(cart.total_price) + '</span>';
    }

    if (cartFooter) {
      cartFooter.style.display = cart.item_count > 0 ? '' : 'none';
    }

    // Update free shipping progress
    updateFreeShippingProgress(cart.total_price);
  }

  /** Refresh the cart drawer by fetching /cart.js */
  function refreshCartDrawer(callback) {
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      if (typeof callback === 'function') callback(cart);
    });
  }

  // ============================================
  // 3. CRITICAL - External Checkout Button
  // ============================================
  function initExternalCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.external-checkout-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var externalUrl = getShopData('externalCheckoutUrl');
      if (!externalUrl) {
        showToast('Checkout is not configured', 'error');
        return;
      }

      btn.disabled = true;
      btn.innerHTML = '<span class="btn-spinner"></span>';

      fetchCart().then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          showToast('Your cart is empty', 'error');
          btn.disabled = false;
          btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Proceed to Checkout';
          return;
        }

        // Build SKU:QTY pairs
        var pairs = [];
        cart.items.forEach(function (item) {
          var sku = item.sku || item.variant_id;
          pairs.push(sku + ':' + item.quantity);
        });

        var checkoutUrl = externalUrl + '/?add-to-cart=' + pairs.join(',');
        window.location.href = checkoutUrl;
      }).catch(function () {
        showToast('Error preparing checkout', 'error');
        btn.disabled = false;
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Proceed to Checkout';
      });
    });
  }

  // ============================================
  // Cart Item Remove & Quantity Update (AJAX)
  // ============================================
  function initCartItemActions() {
    // Remove item
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cart-item-remove');
      if (!removeBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var key = removeBtn.dataset.key;
      if (!key) return;

      var cartItem = removeBtn.closest('.cart-item');
      if (cartItem) {
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
        credentials: 'same-origin'
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        showToast('Item removed from cart');
      })
      .catch(function () {
        if (cartItem) {
          cartItem.style.opacity = '';
          cartItem.style.pointerEvents = '';
        }
        showToast('Error removing item', 'error');
      });
    });

    // Quantity +/- in cart drawer
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-item-quantity .qty-btn');
      if (!qtyBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var key = qtyBtn.dataset.key;
      if (!key) return;

      var container = qtyBtn.closest('.cart-item-quantity');
      var qtyValue = container ? container.querySelector('.qty-value') : null;
      if (!qtyValue) return;

      var quantity = parseInt(qtyValue.textContent) || 1;
      if (qtyBtn.classList.contains('minus')) {
        quantity = Math.max(1, quantity - 1);
      } else if (qtyBtn.classList.contains('plus')) {
        quantity = quantity + 1;
      }

      // Update display immediately
      qtyValue.textContent = quantity;

      // Debounce the AJAX call
      clearTimeout(qtyBtn._debounce);
      qtyBtn._debounce = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
          credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCartDrawer(cart);
        });
      }, 300);
    });
  }

  // ============================================
  // 10. Product Card Add to Cart
  // ============================================
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId || btn.dataset.productId;
      if (!variantId) return;

      // Read quantity from card qty selector if present
      var card = btn.closest('.product-card');
      var qtyEl = card ? card.querySelector('[data-card-qty-value]') : null;
      var qty = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;

      addToCartAjax(variantId, qty, btn);
    });
  }

  function addToCartAjax(variantId, quantity, btn) {
    if (!variantId) return;

    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.textContent = 'Adding...';
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 }),
      credentials: 'same-origin'
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function () {
      // Refresh cart drawer then open it
      refreshCartDrawer(function () {
        if (window.openCartSidebar) window.openCartSidebar();
      });

      if (btn) {
        btn.textContent = 'Added!';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      }

      showToast('Product added to cart!');
    })
    .catch(function () {
      if (btn) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
      showToast('Could not add to cart', 'error');
    });
  }

  /** Intercept product form submission on PDP */
  function initProductFormAjax() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();

      var addBtn = form.querySelector('[type="submit"]');
      if (!addBtn || addBtn.disabled) return;

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      var qtyInput = form.querySelector('[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      addToCartAjax(variantId, quantity, addBtn);
    });
  }

  // ============================================
  // 4. Search Drawer
  // ============================================
  function initSearchSidebar() {
    var searchBtns = document.querySelectorAll('[data-search-trigger]');
    var searchDrawer = document.querySelector('[data-search-drawer]');
    var searchClose = document.querySelectorAll('[data-search-close]');
    var searchOverlay = document.querySelector('[data-search-overlay]');

    if (!searchDrawer) return;

    var searchInput = searchDrawer.querySelector('[data-search-input]');
    var searchPopular = searchDrawer.querySelector('[data-search-popular]');
    var searchResultsList = searchDrawer.querySelector('[data-search-results-list]');
    var searchLoading = searchDrawer.querySelector('[data-search-loading]');
    var searchNoResults = searchDrawer.querySelector('[data-search-no-results]');
    var searchClear = searchDrawer.querySelector('[data-search-clear]');
    var searchDebounce = null;

    function openSearch() {
      searchDrawer.classList.add('active');
      if (searchOverlay) searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
    }

    function closeSearch() {
      searchDrawer.classList.remove('active');
      if (searchOverlay) searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = this.value.trim();
        clearTimeout(searchDebounce);

        if (searchClear) searchClear.style.display = query.length > 0 ? '' : 'none';

        if (query.length < 1) {
          if (searchPopular) searchPopular.style.display = '';
          if (searchResultsList) searchResultsList.innerHTML = '';
          if (searchLoading) searchLoading.style.display = 'none';
          if (searchNoResults) searchNoResults.style.display = 'none';
          return;
        }

        searchDebounce = setTimeout(function () {
          if (searchPopular) searchPopular.style.display = 'none';
          if (searchLoading) searchLoading.style.display = '';
          if (searchNoResults) searchNoResults.style.display = 'none';

          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10', {
            credentials: 'same-origin'
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (searchLoading) searchLoading.style.display = 'none';
            var products = data.resources && data.resources.results && data.resources.results.products
              ? data.resources.results.products : [];

            if (products.length === 0) {
              if (searchNoResults) searchNoResults.style.display = '';
              if (searchResultsList) searchResultsList.innerHTML = '';
              return;
            }

            var html = '';
            products.forEach(function (product) {
              var img = product.image || '';
              var priceCents = product.price ? Math.round(parseFloat(product.price) * 100) : 0;
              var price = priceCents ? formatPriceFromCents(priceCents) : '';
              html +=
                '<a href="' + product.url + '" class="search-result-item">' +
                  (img ? '<img class="search-result-img" src="' + img + '" alt="' + product.title + '" loading="lazy">' : '<div class="search-result-img"></div>') +
                  '<div class="search-result-info">' +
                    '<span class="search-result-name">' + product.title + '</span>' +
                    (price ? '<span class="search-result-price money" data-base-price="' + priceCents + '">' + price + '</span>' : '') +
                  '</div>' +
                '</a>';
            });
            html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-view-all">View all results &rarr;</a>';
            if (searchResultsList) searchResultsList.innerHTML = html;
          })
          .catch(function () {
            if (searchLoading) searchLoading.style.display = 'none';
            if (searchNoResults) searchNoResults.style.display = '';
          });
        }, 150);
      });

      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = this.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        if (searchInput) { searchInput.value = ''; searchInput.focus(); }
        if (searchResultsList) searchResultsList.innerHTML = '';
        if (searchPopular) searchPopular.style.display = '';
        if (searchNoResults) searchNoResults.style.display = 'none';
        searchClear.style.display = 'none';
      });
    }

    searchBtns.forEach(function (btn) { btn.addEventListener('click', openSearch); });
    searchClose.forEach(function (btn) { btn.addEventListener('click', closeSearch); });
    if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchDrawer.classList.contains('active')) closeSearch();
    });
  }

  // ============================================
  // 5. Currency Conversion (Client-side)
  // ============================================
  function initCurrencySelector() {
    var selector = document.getElementById('currencySelector');
    if (!selector) return;

    var trigger = selector.querySelector('.currency-trigger');
    var options = selector.querySelectorAll('.currency-option');
    var flagEl = selector.querySelector('.currency-trigger .currency-flag');
    var codeEl = selector.querySelector('.currency-trigger .currency-code');
    var dropdown = selector.querySelector('.currency-dropdown');
    var activeCurrency = 'GBP';

    // Mobile overlay for bottom-sheet
    var mobileOverlay = document.createElement('div');
    mobileOverlay.className = 'currency-mobile-overlay';
    document.body.appendChild(mobileOverlay);

    function scanAndConvertPrices(currency) {
      var rates = getShopData('exchangeRates') || {};
      var rate = rates[currency] || 1;
      var symbol = CURRENCY_SYMBOLS[currency] || '\u00a3';

      // Convert all elements with class "money" or data-base-price
      var priceEls = document.querySelectorAll('.money, [data-base-price]');
      priceEls.forEach(function (el) {
        var basePrice = el.getAttribute('data-base-price');
        if (basePrice) {
          // data-base-price is in cents (GBP)
          var cents = parseInt(basePrice);
          if (!isNaN(cents)) {
            var converted = ((cents / 100) * rate).toFixed(2);
            el.textContent = symbol + converted;
          }
        } else {
          // For elements without data-base-price, store original and convert
          var stored = el.getAttribute('data-gbp-original');
          if (!stored) {
            var text = el.textContent.replace(/[^0-9.,-]/g, '').replace(',', '');
            var num = parseFloat(text);
            if (!isNaN(num)) {
              el.setAttribute('data-gbp-original', num.toString());
              stored = num.toString();
            }
          }
          if (stored) {
            var originalGBP = parseFloat(stored);
            if (!isNaN(originalGBP)) {
              var converted = (originalGBP * rate).toFixed(2);
              el.textContent = symbol + converted;
            }
          }
        }
      });
    }

    function selectCurrency(currency) {
      activeCurrency = currency;

      // Update trigger display
      options.forEach(function (o) { o.classList.remove('active'); });
      var opt = selector.querySelector('[data-currency="' + currency + '"]');
      if (dropdown) {
        var optInDropdown = dropdown.querySelector('[data-currency="' + currency + '"]');
        if (optInDropdown) optInDropdown.classList.add('active');
      }
      if (opt) opt.classList.add('active');

      if (codeEl) codeEl.textContent = currency;
      if (opt && flagEl) {
        var flagSrc = opt.getAttribute('data-flag-src');
        var trigImg = flagEl.querySelector('img');
        if (trigImg && flagSrc) {
          trigImg.src = flagSrc;
          trigImg.alt = currency;
        }
      }

      // Apply price conversion
      scanAndConvertPrices(currency);

      // Re-scan after a tick to catch any elements that rendered late (e.g. Swiper)
      setTimeout(function() { scanAndConvertPrices(currency); }, 50);

      // Save to localStorage
      try { localStorage.setItem('shark_currency', currency); } catch (e) {}

      // Update URL param
      var url = new URL(window.location.href);
      if (currency === 'GBP') {
        url.searchParams.delete('currency');
      } else {
        url.searchParams.set('currency', currency);
      }
      window.history.replaceState({}, '', url.toString());
    }

    function openDropdown() {
      selector.classList.add('open');
      if (window.innerWidth <= 768 && dropdown) {
        document.body.appendChild(dropdown);
        dropdown.offsetHeight; // force reflow
        dropdown.classList.add('mobile-open');
        mobileOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeDropdown() {
      selector.classList.remove('open');
      if (dropdown && dropdown.classList.contains('mobile-open')) {
        dropdown.classList.remove('mobile-open');
        mobileOverlay.classList.remove('active');
        document.body.style.overflow = '';
        selector.appendChild(dropdown);
      } else {
        mobileOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (selector.classList.contains('open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });
    }

    mobileOverlay.addEventListener('click', closeDropdown);
    document.addEventListener('click', function(e) {
      if (!selector.contains(e.target)) closeDropdown();
    });

    // Mobile swipe-to-dismiss for currency drawer
    (function() {
      if (!dropdown) return;
      var startY = 0, currentY = 0, isDragging = false;

      function onTouchStart(e) {
        if (window.innerWidth > 768 || !dropdown.classList.contains('mobile-open')) return;
        startY = e.touches[0].clientY;
        currentY = startY;
        isDragging = true;
        dropdown.classList.add('dragging');
      }

      function onTouchMove(e) {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        var dy = currentY - startY;
        if (dy < 0) dy = 0; // only allow dragging down
        dropdown.style.transform = 'translateY(' + dy + 'px)';
        // Fade overlay proportionally
        var progress = Math.min(dy / 200, 1);
        mobileOverlay.style.opacity = 1 - progress;
        if (dy > 10) e.preventDefault();
      }

      function onTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
        dropdown.classList.remove('dragging');
        dropdown.style.transform = '';
        mobileOverlay.style.opacity = '';
        var dy = currentY - startY;
        if (dy > 80) {
          closeDropdown();
        }
      }

      dropdown.addEventListener('touchstart', onTouchStart, { passive: true });
      dropdown.addEventListener('touchmove', onTouchMove, { passive: false });
      dropdown.addEventListener('touchend', onTouchEnd, { passive: true });
    })();

    if (dropdown) {
      dropdown.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectCurrency(opt.dataset.currency);
        closeDropdown();
      });
    });

    // Fetch live exchange rates, then restore saved currency
    function fetchLiveRates(callback) {
      var cacheKey = 'shark_rates_cache', cacheTimeKey = 'shark_rates_time', ONE_HOUR = 3600000;
      try {
        var ct = parseInt(localStorage.getItem(cacheTimeKey)), cd = localStorage.getItem(cacheKey);
        if (cd && ct && (Date.now() - ct < ONE_HOUR)) {
          var cached = JSON.parse(cd);
          if (window.shopData) window.shopData.exchangeRates = cached;
          callback(); return;
        }
      } catch (e) {}
      fetch('https://open.er-api.com/v6/latest/GBP')
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d && d.rates) {
            var rates = { GBP: 1, EUR: d.rates.EUR || 1, USD: d.rates.USD || 1, AUD: d.rates.AUD || 1, CAD: d.rates.CAD || 1 };
            if (window.shopData) window.shopData.exchangeRates = rates;
            try { localStorage.setItem(cacheKey, JSON.stringify(rates)); localStorage.setItem(cacheTimeKey, Date.now().toString()); } catch(e) {}
          }
          callback();
        })
        .catch(function() {
          fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/gbp.json')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              if (d && d.gbp) {
                var rates = { GBP: 1, EUR: d.gbp.eur || 1, USD: d.gbp.usd || 1, AUD: d.gbp.aud || 1, CAD: d.gbp.cad || 1 };
                if (window.shopData) window.shopData.exchangeRates = rates;
                try { localStorage.setItem(cacheKey, JSON.stringify(rates)); localStorage.setItem(cacheTimeKey, Date.now().toString()); } catch(e) {}
              }
              callback();
            })
            .catch(function() { callback(); });
        });
    }

    // Determine initial currency: URL param > localStorage > GBP
    function initCurrency() {
      var urlCurrency = new URL(window.location.href).searchParams.get('currency');
      var savedCurrency = null;
      try { savedCurrency = localStorage.getItem('shark_currency'); } catch (e) {}
      var initialCurrency = urlCurrency || savedCurrency || 'GBP';
      if (!selector.querySelector('[data-currency="' + initialCurrency + '"]')) {
        initialCurrency = 'GBP';
      }
      selectCurrency(initialCurrency);
    }

    fetchLiveRates(initCurrency);

    // Re-apply currency when cart drawer is updated (MutationObserver)
    var cartContainer = document.querySelector('[data-cart-drawer]');
    if (cartContainer) {
      var mutationTimer = null;
      var observer = new MutationObserver(function () {
        if (activeCurrency === 'GBP') return;
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function () {
          scanAndConvertPrices(activeCurrency);
        }, 100);
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    }

    // Expose for external use (reads from localStorage so it works even before fetchLiveRates completes)
    window.sharkConvertPrices = function () {
      var currency = activeCurrency !== 'GBP' ? activeCurrency : getActiveCurrency();
      scanAndConvertPrices(currency);
    };

    // Re-apply conversion on window load to catch any late-rendered elements (e.g. PDP)
    window.addEventListener('load', function () {
      var currency = activeCurrency !== 'GBP' ? activeCurrency : getActiveCurrency();
      if (currency !== 'GBP') {
        scanAndConvertPrices(currency);
      }
    });
  }

  // ============================================
  // 6. Header Scroll Effect
  // ============================================
  function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;

    var lastScroll = 0;

    window.addEventListener('scroll', function () {
      var currentScroll = window.pageYOffset;

      if (currentScroll > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      // Logo swap: scrolling down = shark icon, scrolling up/at top = full logo
      if (currentScroll > 80 && currentScroll > lastScroll) {
        header.classList.add('logo-scrolled');
      } else if (currentScroll < lastScroll || currentScroll <= 80) {
        header.classList.remove('logo-scrolled');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ============================================
  // 7. Mega Menu (Desktop hover)
  // ============================================
  function initMegaMenu() {
    var dropdowns = document.querySelectorAll('.nav-item.dropdown');

    dropdowns.forEach(function (dropdown) {
      var menu = dropdown.querySelector('.dropdown-menu');
      if (!menu) return;

      var timeout;

      dropdown.addEventListener('mouseenter', function () {
        clearTimeout(timeout);
        menu.classList.add('active');
      });

      dropdown.addEventListener('mouseleave', function () {
        timeout = setTimeout(function () {
          menu.classList.remove('active');
        }, 150);
      });
    });
  }

  // ============================================
  // 8. Hero Slider (auto-rotate + dots + drag)
  // ============================================
  function initHeroSlider() {
    var track = document.querySelector('.hero-slider-track');
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-slider-dot');

    if (!track || slides.length < 2) return;

    var current = 0;
    var interval;

    function goToSlide(index) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      dots.forEach(function (d) { d.classList.remove('active'); });
      slides[index].classList.add('active');
      if (dots[index]) dots[index].classList.add('active');
      current = index;
    }

    function nextSlide() {
      goToSlide((current + 1) % slides.length);
    }

    function prevSlide() {
      goToSlide((current - 1 + slides.length) % slides.length);
    }

    function startAutoplay() {
      interval = setInterval(nextSlide, 5000);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goToSlide(parseInt(this.dataset.slide));
        startAutoplay();
      });
    });

    // Desktop drag support
    var dragStartX = 0;
    var isDragging = false;

    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      track.style.cursor = 'grabbing';
      stopAutoplay();
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
    });

    document.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      var diff = e.clientX - dragStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) nextSlide(); else prevSlide();
      }
      startAutoplay();
    });

    // Touch support
    track.addEventListener('touchstart', function (e) {
      dragStartX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - dragStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) nextSlide(); else prevSlide();
      }
      startAutoplay();
    });

    startAutoplay();
  }

  // ============================================
  // 9. FAQ Accordion
  // ============================================
  function initFaqAccordion() {
    document.addEventListener('click', function (e) {
      var question = e.target.closest('.faq-question');
      if (!question) return;

      var item = question.closest('.faq-item');
      if (!item) return;

      var wasActive = item.classList.contains('active');

      // Close all other items
      document.querySelectorAll('.faq-item.active').forEach(function (i) {
        i.classList.remove('active');
      });

      // Toggle current
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  }

  // ============================================
  // 11. Reviews Filtering & Sorting
  // ============================================
  function initStampedWidget() {
    var grid = document.getElementById('reviewsGrid');
    if (!grid) return;

    var cards = Array.from(grid.querySelectorAll('.stamped-review-card'));
    var pills = document.querySelectorAll('.stamped-pill');
    var barRows = document.querySelectorAll('.stamped-filter-bar');
    var sortSelect = document.getElementById('stampedSort');
    var searchInput = document.getElementById('rpSearch');
    var noResults = document.getElementById('stampedNoResults');
    var activeFilter = 'all';
    var MAX_VISIBLE = 6;

    function applyFilter(filter) {
      if (typeof filter !== 'undefined') activeFilter = filter;
      var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
      var visible = 0;
      cards.forEach(function (card) {
        var matchesRating = activeFilter === 'all' || card.dataset.rating === String(activeFilter);
        var matchesSearch = !query || card.textContent.toLowerCase().indexOf(query) !== -1;
        if (matchesRating && matchesSearch && visible < MAX_VISIBLE) {
          card.removeAttribute('data-hidden');
          card.style.display = '';
          visible++;
        } else {
          card.setAttribute('data-hidden', 'true');
          card.style.display = 'none';
        }
      });
      if (noResults) {
        noResults.style.display = visible === 0 ? '' : 'none';
      }
    }

    if (searchInput) {
      var debounce;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { applyFilter(); }, 200);
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        barRows.forEach(function (b) { b.classList.remove('active'); });
        if (pill.dataset.filter !== 'all') {
          var matchBar = document.querySelector('.stamped-filter-bar[data-filter="' + pill.dataset.filter + '"]');
          if (matchBar) matchBar.classList.add('active');
        }
        applyFilter(pill.dataset.filter);
      });
    });

    barRows.forEach(function (bar) {
      bar.addEventListener('click', function () {
        var stars = bar.dataset.filter;
        if (bar.classList.contains('active')) {
          barRows.forEach(function (b) { b.classList.remove('active'); });
          pills.forEach(function (p) { p.classList.remove('active'); });
          var allPill = document.querySelector('.stamped-pill[data-filter="all"]');
          if (allPill) allPill.classList.add('active');
          applyFilter('all');
        } else {
          barRows.forEach(function (b) { b.classList.remove('active'); });
          bar.classList.add('active');
          pills.forEach(function (p) { p.classList.remove('active'); });
          var matchPill = document.querySelector('.stamped-pill[data-filter="' + stars + '"]');
          if (matchPill) matchPill.classList.add('active');
          applyFilter(stars);
        }
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var sortBy = this.value;
        var sorted = cards.slice().sort(function (a, b) {
          if (sortBy === 'highest') return (parseInt(b.dataset.rating) || 0) - (parseInt(a.dataset.rating) || 0);
          if (sortBy === 'lowest') return (parseInt(a.dataset.rating) || 0) - (parseInt(b.dataset.rating) || 0);
          return 0;
        });
        sorted.forEach(function (card) { grid.appendChild(card); });
        applyFilter();
      });
    }

    // Helpful buttons
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.stamped-helpful-btn');
      if (!btn || btn.classList.contains('voted')) return;
      btn.classList.add('voted');
      var count = parseInt(btn.dataset.count || '0') + 1;
      btn.dataset.count = count;
      var countEl = btn.querySelector('.stamped-helpful-count');
      if (countEl) countEl.textContent = '(' + count + ')';
      btn.style.color = 'var(--success)';
      btn.style.borderColor = 'var(--success)';
    });

    applyFilter('all');
  }

  function initReviewsFilter() {
    var filterBtns = document.querySelectorAll('.reviews-filter-btn');
    var grid = document.getElementById('reviewsGrid');
    if (!filterBtns.length || !grid) return;

    var cards = grid.querySelectorAll('.testimonial-card');

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.dataset.filter;

        cards.forEach(function (card) {
          if (filter === 'all' || card.dataset.rating === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Breakdown bar clicks
    document.querySelectorAll('.reviews-filter-bar').forEach(function (bar) {
      bar.addEventListener('click', function () {
        var stars = bar.dataset.filter;
        var matchBtn = document.querySelector('.reviews-filter-btn[data-filter="' + stars + '"]');
        if (matchBtn) matchBtn.click();
      });
    });
  }

  function initReviewsSort() {
    var dropdown = document.getElementById('reviewsSortDropdown');
    if (!dropdown) return;

    var trigger = dropdown.querySelector('.reviews-sort-trigger');
    var label = dropdown.querySelector('.reviews-sort-label');
    var options = dropdown.querySelectorAll('.reviews-sort-option');
    var grid = document.getElementById('reviewsGrid');

    if (!trigger || !grid) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
      trigger.setAttribute('aria-expanded', dropdown.classList.contains('open'));
    });

    document.addEventListener('click', function () {
      dropdown.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        if (label) label.textContent = opt.textContent;
        dropdown.classList.remove('open');

        var cards = Array.from(grid.querySelectorAll('.testimonial-card'));
        var sortBy = opt.dataset.sort;

        cards.sort(function (a, b) {
          if (sortBy === 'highest') return (parseInt(b.dataset.rating) || 0) - (parseInt(a.dataset.rating) || 0);
          if (sortBy === 'lowest') return (parseInt(a.dataset.rating) || 0) - (parseInt(b.dataset.rating) || 0);
          var ai = cards.indexOf(a);
          var bi = cards.indexOf(b);
          return sortBy === 'oldest' ? bi - ai : ai - bi;
        });

        cards.forEach(function (card) { grid.appendChild(card); });
      });
    });
  }

  function initReviewsPage() {
    var list = document.getElementById('rpList');
    if (!list) return;

    var pills = document.querySelectorAll('#rpFilters .rp-filter-pill');
    var sortSelect = document.getElementById('rpSortSelect');
    var searchInput = document.getElementById('rpSearch');
    var barRows = document.querySelectorAll('.rp-bar-row');
    var reviews = Array.from(list.querySelectorAll('.rp-card, .rp-review'));
    var activeFilter = 'all';

    function applyFilters() {
      var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
      reviews.forEach(function (r) {
        var matchesRating = activeFilter === 'all' || r.dataset.rating === String(activeFilter);
        var matchesSearch = !query || r.textContent.toLowerCase().indexOf(query) !== -1;
        r.style.display = matchesRating && matchesSearch ? '' : 'none';
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        activeFilter = pill.dataset.filter;
        applyFilters();
      });
    });

    barRows.forEach(function (row) {
      row.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        var match = document.querySelector('#rpFilters .rp-filter-pill[data-filter="' + row.dataset.filter + '"]');
        if (match) match.classList.add('active');
        activeFilter = row.dataset.filter;
        applyFilters();
      });
    });

    if (searchInput) {
      var debounce;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(applyFilters, 200);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var sorted = reviews.slice().sort(function (a, b) {
          var sortBy = sortSelect.value;
          if (sortBy === 'highest') return (parseInt(b.dataset.rating) || 0) - (parseInt(a.dataset.rating) || 0);
          if (sortBy === 'lowest') return (parseInt(a.dataset.rating) || 0) - (parseInt(b.dataset.rating) || 0);
          var ai = reviews.indexOf(a);
          var bi = reviews.indexOf(b);
          return sortBy === 'oldest' ? bi - ai : ai - bi;
        });
        sorted.forEach(function (r) { list.appendChild(r); });
      });
    }
  }

  // ============================================
  // 12. Chatbot
  // ============================================
  function initChatbot() {
    var launcher = document.getElementById('chatbotLauncher');
    var fab = document.getElementById('chatbotFab');
    var panel = document.getElementById('chatbotPanel');
    if (!launcher || !fab || !panel) return;

    var chatbotData = { goal: '', experience: '' };

    fab.addEventListener('click', function () {
      launcher.classList.toggle('open');
    });

    document.addEventListener('click', function (e) {
      if (!launcher.contains(e.target) && launcher.classList.contains('open')) {
        launcher.classList.remove('open');
      }
    });

    function showScreen(name) {
      var current = panel.querySelector('.chatbot-screen--active');
      var next = panel.querySelector('[data-screen="' + name + '"]');
      if (current) current.classList.remove('chatbot-screen--active');
      if (next) next.classList.add('chatbot-screen--active');
    }

    // Product recommendation map: goal + experience -> product
    var recommendations = {
      bulking: {
        beginner: { name: 'Turkesterone', reason: 'A powerful natural anabolic for building lean muscle without SARMs.', url: '/products/turkesterone', badge: 'Natty pick' },
        experienced: { name: 'RAD 140 (Testolone)', reason: 'The gold standard for lean mass and strength gains.', url: '/products/rad-140-10mg', badge: 'Best for bulking', showStacks: true }
      },
      cutting: {
        beginner: { name: 'Tongkat Ali', reason: 'Supports natural testosterone and body composition.', url: '/products/tongkat-ali', badge: 'Natty pick' },
        experienced: { name: 'Cardarine (GW-501516)', reason: 'Boosts fat oxidation and endurance for clean cuts.', url: '/products/cardarine-gw-501516-10mg', badge: 'Best for cutting', showStacks: true }
      },
      strength: {
        beginner: { name: 'Fadogia Agrestis', reason: 'Natural testosterone support for strength and performance.', url: '/products/fadogia-agrestis', badge: 'Natty pick' },
        experienced: { name: 'Ligandrol (LGD-4033)', reason: 'Maximise strength and power output with proven results.', url: '/products/ligandrol-lgd-4033-10mg', badge: 'Best for strength', showStacks: true }
      },
      recovery: {
        beginner: { name: 'Tongkat Ali', reason: 'Supports recovery, hormone balance and overall well-being.', url: '/products/tongkat-ali', badge: 'Natty pick' },
        experienced: { name: 'MK-677 (Ibutamoren)', reason: 'Promotes deep sleep, recovery and growth hormone release.', url: '/products/ibutamoren-mk-677-10mg', badge: 'Best for recovery', showStacks: true }
      }
    };

    function populateRecommendation() {
      var goal = chatbotData.goal;
      var exp = chatbotData.experience;
      if (!goal || !exp || !recommendations[goal]) return;

      var rec = recommendations[goal][exp];
      if (!rec) return;

      var nameEl = document.getElementById('chatbotRecName');
      var reasonEl = document.getElementById('chatbotRecReason');
      var linkEl = document.getElementById('chatbotRecLink');
      var badgeEl = document.getElementById('chatbotRecBadge');
      var altEl = document.getElementById('chatbotRecAlt');

      if (nameEl) nameEl.textContent = rec.name;
      if (reasonEl) reasonEl.textContent = rec.reason;
      if (linkEl) linkEl.href = rec.url;
      if (badgeEl) badgeEl.textContent = rec.badge;
      if (altEl) altEl.style.display = rec.showStacks ? '' : 'none';
    }

    // Navigate between screens
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-goto]');
      if (!btn) return;

      if (btn.dataset.goal) chatbotData.goal = btn.dataset.goal;
      if (btn.dataset.experience) chatbotData.experience = btn.dataset.experience;

      if (btn.dataset.goto === 'recommendation') {
        populateRecommendation();
      }

      showScreen(btn.dataset.goto);
    });

    // Contact form
    var contactForm = document.getElementById('chatbotContactForm');
    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = this.querySelector('button[type="submit"]');
        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;

        setTimeout(function () {
          showScreen('success');
          var successH4 = panel.querySelector('.chatbot-success h4');
          var successP = panel.querySelector('.chatbot-success p');
          if (successH4) successH4.textContent = 'Message sent!';
          if (successP) successP.textContent = "We'll get back to you within 24 hours.";
        }, 500);
      });
    }
  }

  // ============================================
  // 13. Scroll Animations (IntersectionObserver)
  // ============================================
  function initRevealAnimations() {
    var reveals = document.querySelectorAll('.reveal, .reveal-right');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    reveals.forEach(function (el) { observer.observe(el); });
  }

  // ============================================
  // 14. Quantity Selectors (generic +/- buttons)
  // ============================================
  function initQuantityButtons() {
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.quantity .qty-btn, .pdp-add-to-cart .qty-btn, .product-detail__add-to-cart .qty-btn');
      if (!qtyBtn) return;

      // Skip cart drawer quantity buttons (handled by initCartItemActions)
      if (qtyBtn.closest('.cart-item-quantity')) return;

      // Skip PDP quantity buttons (handled by direct listeners in main-product.liquid)
      if (qtyBtn.closest('.pdp-add-to-cart')) return;

      var container = qtyBtn.closest('.quantity');
      if (!container) return;

      var input = container.querySelector('.qty, input[type="number"]');
      if (!input) return;

      var value = parseInt(input.value) || 1;

      if (qtyBtn.classList.contains('minus') || qtyBtn.classList.contains('qty-minus') || qtyBtn.textContent.trim() === '\u2212' || qtyBtn.textContent.trim() === '-') {
        var min = parseInt(input.getAttribute('min')) || 1;
        value = Math.max(min, value - 1);
      } else if (qtyBtn.classList.contains('plus') || qtyBtn.classList.contains('qty-plus') || qtyBtn.textContent.trim() === '+') {
        var max = parseInt(input.getAttribute('max')) || 999;
        value = Math.min(max, value + 1);
      }

      input.value = value;
      input.dispatchEvent(new Event('change'));
    });

    // Product card quantity +/- buttons
    document.addEventListener('click', function (e) {
      var cardQtyBtn = e.target.closest('[data-card-qty-minus], [data-card-qty-plus]');
      if (!cardQtyBtn) return;
      e.preventDefault();
      e.stopPropagation();

      var container = cardQtyBtn.closest('[data-card-qty]');
      if (!container) return;

      var display = container.querySelector('[data-card-qty-value]');
      if (!display) return;

      var value = parseInt(display.textContent) || 1;

      if (cardQtyBtn.hasAttribute('data-card-qty-minus')) {
        value = Math.max(1, value - 1);
      } else {
        value = Math.min(99, value + 1);
      }

      display.textContent = value;
    });
  }

  // ============================================
  // 15. Mobile Navigation Submenus
  // ============================================
  // (Handled within initMobileMenu above via .mobile-nav-toggle)

  // ============================================
  // 16. Free Shipping Progress Bar
  // ============================================
  function updateFreeShippingProgress(cartTotalCents) {
    var thresholdPounds = getShopData('freeShippingThreshold');
    if (!thresholdPounds) return;

    var threshold = thresholdPounds * 100; // convert pounds to pence
    var progressBars = document.querySelectorAll('.free-shipping-progress');
    if (!progressBars.length) return;

    var percentage = Math.min((cartTotalCents / threshold) * 100, 100);
    var remaining = threshold - cartTotalCents;

    progressBars.forEach(function (container) {
      var bar = container.querySelector('.free-shipping-fill');
      var message = container.querySelector('.shipping-message');

      if (bar) {
        bar.style.width = percentage + '%';
        if (remaining <= 0) {
          bar.classList.add('complete');
        } else {
          bar.classList.remove('complete');
        }
      }

      if (message) {
        if (remaining <= 0) {
          message.className = 'shipping-message free-shipping-text achieved';
          message.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> You\'ve unlocked <strong>FREE shipping!</strong>';
          container.classList.add('shipping-unlocked');
        } else {
          message.className = 'shipping-message free-shipping-text';
          message.innerHTML = 'Spend <strong>' + formatPriceFromCents(remaining) + '</strong> more to unlock <strong>FREE shipping!</strong>';
          container.classList.remove('shipping-unlocked');
        }
      }
    });
  }

  // ============================================
  // 17. Product Gallery (PDP)
  // ============================================
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-thumbnail');
    var mainImage = document.querySelector('.product-main-image');

    if (!thumbs.length || !mainImage) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        mainImage.src = this.dataset.fullImage || this.src;
        mainImage.alt = this.alt || '';
      });
    });

    // Simple lightbox
    if (mainImage) {
      mainImage.addEventListener('click', function () {
        var lightbox = document.createElement('div');
        lightbox.className = 'product-lightbox';
        lightbox.innerHTML =
          '<div class="product-lightbox-overlay"></div>' +
          '<div class="product-lightbox-content">' +
            '<button class="product-lightbox-close" aria-label="Close">&times;</button>' +
            '<img src="' + mainImage.src + '" alt="' + (mainImage.alt || '') + '">' +
          '</div>';
        document.body.appendChild(lightbox);
        document.body.style.overflow = 'hidden';

        function closeLightbox() {
          lightbox.remove();
          document.body.style.overflow = '';
        }

        lightbox.querySelector('.product-lightbox-overlay').addEventListener('click', closeLightbox);
        lightbox.querySelector('.product-lightbox-close').addEventListener('click', closeLightbox);
        document.addEventListener('keydown', function handler(e) {
          if (e.key === 'Escape') {
            closeLightbox();
            document.removeEventListener('keydown', handler);
          }
        });
      });
    }
  }

  // ============================================
  // 18. Shop Sort Dropdown (Collection pages)
  // ============================================
  function initShopSortDropdown() {
    var sortDropdown = document.getElementById('shopSortDropdown');
    if (!sortDropdown) return;

    var trigger = sortDropdown.querySelector('.sort-trigger');
    var panel = sortDropdown.querySelector('.sort-panel');

    if (!trigger || !panel) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      sortDropdown.classList.toggle('open');
    });

    document.addEventListener('click', function (e) {
      if (!sortDropdown.contains(e.target)) {
        sortDropdown.classList.remove('open');
      }
    });

    sortDropdown.querySelectorAll('.sort-panel-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var sortVal = this.dataset.sort;

        // Update active states
        sortDropdown.querySelectorAll('.sort-panel-item').forEach(function (i) { i.classList.remove('active'); });
        this.classList.add('active');
        var label = sortDropdown.querySelector('.sort-trigger-label');
        if (label) label.textContent = this.textContent.trim();
        sortDropdown.classList.remove('open');

        // Navigate to sorted URL (Shopify uses ?sort_by= param)
        if (sortVal) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortVal);
          window.location.href = url.toString();
        }
      });
    });
  }

  // ============================================
  // Smooth Scroll for Anchor Links
  // ============================================
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var targetId = link.getAttribute('href');
      if (targetId === '#' || !targetId) return;

      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // ============================================
  // Article / Blog extras
  // ============================================
  function initArticleExtras() {
    // Reading progress bar
    var progressBar = document.getElementById('readingProgress');
    if (progressBar) {
      window.addEventListener('scroll', function () {
        var scrollTop = window.pageYOffset;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        progressBar.style.width = Math.min(progress, 100) + '%';
      }, { passive: true });
    }

    // Copy link buttons
    document.querySelectorAll('.article-copy-link').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            btn.style.background = 'var(--success)';
            btn.style.color = '#fff';
            setTimeout(function () {
              btn.style.background = '';
              btn.style.color = '';
            }, 1500);
          });
        }
      });
    });
  }

  // ============================================
  // Shop Sidebar Filters (collection page)
  // ============================================
  function initShopSidebar() {
    var sidebar = document.getElementById('shopSidebar');
    var openBtn = document.getElementById('mobileFilterBtn');
    var closeBtn = document.getElementById('sidebarClose');
    if (!sidebar) return;

    if (openBtn) {
      openBtn.addEventListener('click', function () { sidebar.classList.add('active'); });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { sidebar.classList.remove('active'); });
    }

    // Collapse toggle for filter sections
    document.querySelectorAll('.filter-title').forEach(function (title) {
      title.addEventListener('click', function () {
        title.parentElement.classList.toggle('collapsed');
      });
    });

    // Price slider
    var minSlider = document.getElementById('priceMin');
    var maxSlider = document.getElementById('priceMax');
    var minInput = document.getElementById('priceMinInput');
    var maxInput = document.getElementById('priceMaxInput');
    var track = document.getElementById('priceSliderTrack');

    if (minSlider && maxSlider && track) {
      function updateSlider() {
        var min = parseInt(minSlider.value);
        var max = parseInt(maxSlider.value);
        if (min > max) { var t = min; min = max; max = t; }
        var range = parseInt(minSlider.max) - parseInt(minSlider.min);
        var left = ((min - parseInt(minSlider.min)) / range) * 100;
        var right = ((max - parseInt(minSlider.min)) / range) * 100;
        track.style.left = left + '%';
        track.style.width = (right - left) + '%';
        if (minInput) minInput.value = min;
        if (maxInput) maxInput.value = max;
      }
      minSlider.addEventListener('input', updateSlider);
      maxSlider.addEventListener('input', updateSlider);
      if (minInput) minInput.addEventListener('change', function () { minSlider.value = this.value; updateSlider(); });
      if (maxInput) maxInput.addEventListener('change', function () { maxSlider.value = this.value; updateSlider(); });
      updateSlider();
    }
  }

  // ============================================
  // Initialize Everything
  // ============================================
  function init() {
    injectToastStyles();

    // 1. Mobile Menu
    initMobileMenu();

    // 2. Cart Drawer
    initCartSidebar();

    // 3. External Checkout
    initExternalCheckout();

    // Cart item actions (remove, qty change)
    initCartItemActions();

    // 4. Search Drawer
    initSearchSidebar();

    // 5. Currency Conversion
    initCurrencySelector();

    // 6. Header Scroll
    initHeaderScroll();

    // 7. Mega Menu
    initMegaMenu();

    // 8. Hero Slider
    initHeroSlider();

    // 9. FAQ Accordion
    initFaqAccordion();

    // 10. Product Card Add to Cart
    initAddToCart();
    initProductFormAjax();

    // 11. Reviews
    initReviewsFilter();
    initReviewsSort();
    initReviewsPage();
    initStampedWidget();

    // 12. Chatbot
    initChatbot();

    // 13. Scroll Animations
    initRevealAnimations();

    // 14. Quantity Selectors
    initQuantityButtons();

    // 16. Free Shipping & Cart Drawer (initial load)
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      updateFreeShippingProgress(cart.total_price);
    }).catch(function () {});

    // 17. Product Gallery
    initProductGallery();

    // 18. Shop Sort Dropdown
    initShopSortDropdown();

    // Extras
    initSmoothScroll();
    initArticleExtras();
    initShopSidebar();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
